import { useEffect } from 'react';

function ScrollToTopAlways() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return null;
}

export default ScrollToTopAlways;